export * from '@platform/services/splash-screen/splash-screen.service';
